// import { ChangeEvent, FC, useEffect, useState } from "react";
// import Modal from "react-modal";
// import close from "assets/images/close.svg";
// import Imgclose from "assets/images/input-img-close-icon.svg";
// import Button from "components/particles/primary-button";

// import { Container, StyledReactModal } from "./style";
// import img from "assets/images/input-img-icon.svg";
// import { useForm } from "react-hook-form";
// import { CategoryDTO } from "utils/helpers/models/categories.dto";
// import FormErrorMessage from "components/particles/forms/form-error-message";

// import useCategories from "containers/categories/useHook";
// import { dispatch } from "store";
// import { setModalClosed } from "store/user-slice";
// import { useSelector } from "react-redux";
// import Spinner from "components/particles/loaders/spinner";
// import Swal from "sweetalert2";
// import { useSearchParams } from "react-router-dom";

// interface AddCategoryModelProps {
//   id: number;
//   data: any;
//   categoriesData: any[];
//   setCategoriesData: Function;
//   searchCategories: Function;
// }

// const AddCategoryModal: FC<AddCategoryModelProps> = ({
//   id,
//   data,
//   categoriesData,
//   setCategoriesData,
//   searchCategories
// }) => {
//   const {
//     register,
//     handleSubmit,
//     setValue,
//     getValues,
//     formState: { errors },
//     reset,
//   } = useForm<CategoryDTO>({
//     defaultValues: {
//       status: true,
//     },
//   });
//   const [selectedImage, setSelectedImage] = useState<string | null>(null);
//   const [status, setStatus] = useState<boolean>(false);
//   const [searchParams] = useSearchParams();
//   const currentCategoryName = searchParams.get("categoryName") || "";
//   const currentStatus = searchParams.get("status") || "";



//   const { postCategories, putCategoryById } = useCategories();
//   const { addCategoriesModalIsOpen, isLoading } = useSelector(
//     (state: any) => state.user
//   );

//   const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
//     const file = event?.target?.files?.[0];

//     if (!file) return;

//     const validTypes = ["image/jpeg", "image/png", "image/jpg"];
//     const maxSize = 1 * 1024 * 1024;

//     if (!validTypes.includes(file.type)) {
//       Swal.fire({
//         icon: "question",
//         title: "Oops...",
//         text: "Only JPG, JPEG, PNG allowed",
//         confirmButtonText: "OK",
//       });
//       event.target.value = "";
//       return;
//     }

//     if (file.size > maxSize) {
//       Swal.fire({
//         icon: "question",
//         title: "Oops...",
//         text: "Image must be less than or equal to 1MB.",
//         confirmButtonText: "OK",
//       });
//       event.target.value = "";
//       return;
//     }

//     setSelectedImage(URL.createObjectURL(file));
//     setValue("image", file);
//   };

//   const customStyles = {
//     content: {
//       top: "50%",
//       left: "50%",
//       right: "auto",
//       bottom: "auto",
//       marginRight: "-50%",
//       transform: "translate(-50%, -50%)",
//       fontSize: "2rem",
//       width: "68.5rem",
//       borderRadius: "3rem",

//     },
//   };

//   function closeModal() {
//     dispatch(setModalClosed("Categories"));
//   }

//   function closeImg() {
//     setSelectedImage(null);
//     setValue("image", null);
//   }

//   useEffect(() => {
//     if (id === 0) {
//       reset(); // Clears other fields
//       setStatus(true); // Set status to true
//       setSelectedImage(null);
//     } else if (data && data.id !== undefined) {
//       for (let key in new CategoryDTO()) {
//         if (data[key] !== undefined) {
//           if (key === "image") {
//             setSelectedImage(data[key]);
//           }
//           if (key === "status") {
//             setStatus(data[key]);
//           }
//           setValue(key as keyof CategoryDTO, data[key]);
//         }
//       }
//     }
//   }, [data, id, reset]);

//   // const onSubmit = async (data: CategoryDTO) => {
//   //   const formData = new FormData();

//   //   for (let key in data) {
//   //     if (key === "status") {
//   //       const status: any = data.status === "Active";
//   //       formData.append(key, status);
//   //     } else {
//   //       formData.append(key, data[key as keyof CategoryDTO]);
//   //     }
//   //   }

//   //   if (id === 0) {
//   //     postCategories(formData);
//   //     await searchCategories(
//   //       "search",
//   //       {
//   //         categoryName: currentCategoryName,
//   //         status: currentStatus,
//   //         offset: 0,
//   //         limit: 10, // or your actual limit
//   //       }
//   //     );

//   //   } else {
//   //     putCategoryById(id, setCategoriesData, categoriesData, data, formData);
//   //     await searchCategories(
//   //       "search",
//   //       {
//   //         categoryName: currentCategoryName,
//   //         status: currentStatus,
//   //         offset: 0,
//   //         limit: 10, // or your actual limit
//   //       }
//   //     );

//   //   }
//   // };
//   const onSubmit = async (data: CategoryDTO) => {
//   const formData = new FormData();

//   for (let key in data) {
//     if (key === "status") {
//       const status: any = data.status === "Active";
//       formData.append(key, status);
//     } else {
//       formData.append(key, data[key as keyof CategoryDTO]);
//     }
//   }

//   if (id === 0) {
//     await postCategories(formData); // ✅ await works
//   } else {
//     await putCategoryById(id, setCategoriesData, categoriesData, data, formData);
//   }

//   // This will only run AFTER post or put is done
//   await searchCategories("search", {
//     categoryName: currentCategoryName,
//     status: currentStatus,
//     offset: 0,
//     limit: 10,
//   });
// };


//   const handleStatusChange = (e: ChangeEvent<HTMLSelectElement>) => {
//     const newStatus = e.target.value === "Active";
//     setStatus(newStatus);
//     setValue("status", newStatus);
//   };

//   return (

//     <StyledReactModal
//       isOpen={addCategoriesModalIsOpen}
//       onRequestClose={closeModal}
//       className="category-modal"
//       contentLabel="Category Modal"
//     >
//       <Container onSubmit={handleSubmit(onSubmit)}>
//         <div className="close-button" onClick={closeModal}>
//           <img src={close} style={{ cursor: "pointer" }} alt="Close" />
//         </div>
//         <div className="model-container">
//           <div
//             className="popup-title"
//             style={{ width: "100%", textAlign: "center", marginTop: "4rem" }}
//           >
//             <h1>{!id ? "Add Category" : "Update Category"}</h1>
//           </div>
//           <div className="add-ingredient-container">
//             <div className="image-container">
//               <div className="image-input-wrapper">
//                 {selectedImage ? (
//                   <>
//                     <img
//                       className="uploaded-image"
//                       src={selectedImage}
//                       alt="Selected"
//                     />
//                     <img
//                       className="close-icon"
//                       src={Imgclose}
//                       alt="Remove"
//                       onClick={closeImg}
//                     />
//                   </>
//                 ) : (
//                   <>
//                     <label htmlFor="image-input">
//                       <img src={img} alt="Upload" />
//                     </label>
//                     <input
//                       id="image-input"
//                       type="file"
//                       accept="image/*"
//                       className="hidden-input"
//                       {...register("image", {
//                         validate: {
//                           fileSize: (fileList: FileList) => {
//                             const file = fileList?.[0];
//                             if (!file) return true;
//                             return (
//                               file.size <= 1 * 1024 * 1024 ||
//                               "File size must be ≤ 1MB"
//                             );
//                           },
//                           fileType: (fileList: FileList) => {
//                             const file = fileList?.[0];
//                             if (!file) return true;
//                             const validTypes = [
//                               "image/jpeg",
//                               "image/png",
//                               "image/jpg",
//                             ];
//                             return (
//                               validTypes.includes(file.type) ||
//                               "Only JPG, JPEG, PNG allowed"
//                             );
//                           },
//                         },
//                       })}
//                       onChange={handleImageChange}
//                     />
//                     <FormErrorMessage error={errors.image} />
//                   </>
//                 )}
//               </div>
//               <p>{getValues("image.name")}</p>
//             </div>
//             <div>
//               <input
//                 type="text"
//                 placeholder="Category Name"
//                 {...register("name", { required: true })}
//               />
//               <FormErrorMessage error={errors.name} />
//             </div>
//             <select
//               id="Status"
//               {...register("status")}
//               value={status ? "Active" : "Inactive"}
//               onChange={handleStatusChange}
//               required
//             >
//               <option value="Active">Active</option>
//               <option value="Inactive">Inactive</option>
//             </select>
//           </div>
//           <div className="add-button">
//             <Button
//               title={isLoading ? <Spinner /> : !id ? "Add" : "Update"}
//               width="51.2rem"
//               backgroundcolor="var(--primary)"
//               fill="true"
//             />
//           </div>
//         </div>
//       </Container>
//     </StyledReactModal>

//   );
// };

// export default AddCategoryModal;

import { ChangeEvent, FC, useEffect, useState } from "react";
import Modal from "react-modal";
import close from "assets/images/close.svg";
import Imgclose from "assets/images/input-img-close-icon.svg";
import Button from "components/particles/primary-button";

import { Container, StyledReactModal } from "./style";
import img from "assets/images/input-img-icon.svg";
import { useForm } from "react-hook-form";
import { CategoryDTO } from "utils/helpers/models/categories.dto";
import FormErrorMessage from "components/particles/forms/form-error-message";

import useCategories from "containers/categories/useHook";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import { useSelector } from "react-redux";
import Spinner from "components/particles/loaders/spinner";
import Swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";

interface AddCategoryModelProps {
  id: number;
  data: any;
  categoriesData: any[];
  setCategoriesData: Function;
  searchCategories: Function;
}

const AddCategoryModal: FC<AddCategoryModelProps> = ({
  id,
  data,
  categoriesData,
  setCategoriesData,
  searchCategories
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    reset,
  } = useForm<CategoryDTO>({
    defaultValues: {
      status: true,
    },
  });
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [status, setStatus] = useState<boolean>(true); // Default to true for new items
  const [searchParams] = useSearchParams();
  const currentCategoryName = searchParams.get("categoryName") || "";
  const currentStatus = searchParams.get("status") || "";

  const { postCategories, putCategoryById } = useCategories();
  const { addCategoriesModalIsOpen, isLoading } = useSelector(
    (state: any) => state.user
  );

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files?.[0];

    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 1 * 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "question",
        title: "Oops...",
        text: "Only JPG, JPEG, PNG allowed",
        confirmButtonText: "OK",
      });
      event.target.value = "";
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "question",
        title: "Oops...",
        text: "Image must be less than or equal to 1MB.",
        confirmButtonText: "OK",
      });
      event.target.value = "";
      return;
    }

    setSelectedImage(URL.createObjectURL(file));
    setValue("image", file);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      fontSize: "2rem",
      width: "68.5rem",
      borderRadius: "3rem",
    },
  };

  function closeModal() {
    dispatch(setModalClosed("Categories"));
    // Reset state when closing
    reset();
    setSelectedImage(null);
    setStatus(true);
  }

  function closeImg() {
    setSelectedImage(null);
    setValue("image", null);
  }

  useEffect(() => {
    if (id === 0) {
      reset(); // Clears other fields
      setStatus(true); // Set status to true for new items
      setSelectedImage(null);
      setValue("status", true);
    } else if (data && data.id !== undefined) {
      for (let key in new CategoryDTO()) {
        if (data[key] !== undefined) {
          if (key === "image") {
            setSelectedImage(data[key]);
          }
          if (key === "status") {
            // Handle both string and boolean status values from API
            const statusValue = data[key] === true || data[key] === "true";
            setStatus(statusValue);
            setValue("status", statusValue);
          } else {
            setValue(key as keyof CategoryDTO, data[key]);
          }
        }
      }
    }
  }, [data, id, reset, setValue]);

  const onSubmit = async (formData: CategoryDTO) => {
    const submitData = new FormData();

    // Get current form values
    const currentValues = getValues();
    
    // Handle each field explicitly
    Object.keys(currentValues).forEach((key) => {
      const typedKey = key as keyof CategoryDTO;
      const value = currentValues[typedKey];
      
      if (key === "status") {
        // Use the current status state value (boolean)
        submitData.append(key, status.toString());
      } else if (key === "image" && value) {
        // Handle image file
        if (value instanceof File) {
          submitData.append(key, value);
        }
      } else if (value !== undefined && value !== null && value !== "") {
        submitData.append(key, String(value));
      }
    });

    try {
      if (id === 0) {
        await postCategories(submitData);
      } else {
        await putCategoryById(id, setCategoriesData, categoriesData, data, submitData);
      }

      // Refresh the categories list after successful operation
      await searchCategories("search", {
        categoryName: currentCategoryName,
        status: currentStatus,
        offset: 0,
        limit: 10,
      });

      closeModal();
    } catch (error) {
      console.error("Error submitting category:", error);
    }
  };

  const handleStatusChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value === "Active";
    setStatus(newStatus);
    setValue("status", newStatus);
  };

  return (
    <StyledReactModal
      isOpen={addCategoriesModalIsOpen}
      onRequestClose={closeModal}
      className="category-modal"
      contentLabel="Category Modal"
    >
      <Container onSubmit={handleSubmit(onSubmit)}>
        <div className="close-button" onClick={closeModal}>
          <img src={close} style={{ cursor: "pointer" }} alt="Close" />
        </div>
        <div className="model-container">
          <div
            className="popup-title"
            style={{ width: "100%", textAlign: "center", marginTop: "4rem" }}
          >
            <h1>{!id ? "Add Category" : "Update Category"}</h1>
          </div>
          <div className="add-ingredient-container">
            <div className="image-container">
              <div className="image-input-wrapper">
                {selectedImage ? (
                  <>
                    <img
                      className="uploaded-image"
                      src={selectedImage}
                      alt="Selected"
                    />
                    <img
                      className="close-icon"
                      src={Imgclose}
                      alt="Remove"
                      onClick={closeImg}
                    />
                  </>
                ) : (
                  <>
                    <label htmlFor="image-input">
                      <img src={img} alt="Upload" />
                    </label>
                    <input
                      id="image-input"
                      type="file"
                      accept="image/*"
                      className="hidden-input"
                      {...register("image", {
                        validate: {
                          fileSize: (fileList: FileList) => {
                            const file = fileList?.[0];
                            if (!file) return true;
                            return (
                              file.size <= 1 * 1024 * 1024 ||
                              "File size must be ≤ 1MB"
                            );
                          },
                          fileType: (fileList: FileList) => {
                            const file = fileList?.[0];
                            if (!file) return true;
                            const validTypes = [
                              "image/jpeg",
                              "image/png",
                              "image/jpg",
                            ];
                            return (
                              validTypes.includes(file.type) ||
                              "Only JPG, JPEG, PNG allowed"
                            );
                          },
                        },
                      })}
                      onChange={handleImageChange}
                    />
                    <FormErrorMessage error={errors.image} />
                  </>
                )}
              </div>
              <p>{getValues("image")?.name || ""}</p>
            </div>
            <div>
              <input
                type="text"
                placeholder="Category Name"
                {...register("name", { required: "Category name is required" })}
              />
              <FormErrorMessage error={errors.name} />
            </div>
            <select
              id="Status"
              value={status ? "Active" : "Inactive"}
              onChange={handleStatusChange}
              required
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
          <div className="add-button">
            <Button
              title={isLoading ? <Spinner /> : !id ? "Add" : "Update"}
              width="51.2rem"
              backgroundcolor="var(--primary)"
              fill="true"
            />
          </div>
        </div>
      </Container>
    </StyledReactModal>
  );
};

export default AddCategoryModal;